import { InsuranceType } from '@Framework/constants/InsuranceType';
import { Box, Divider, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';

import { Button } from '../../atoms/Button/Button';

const useStyles = makeStyles(theme => ({
  title: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px'
    }
  }
}));

export interface RadioSelectProps {
  title?: string;
  label?: string;
  disableJourney?: boolean;
  labelPrivate: string;
  labelPublic: string;
  onChange?: (type: InsuranceType) => void;
  onButtonClick?: () => void;
  value?: InsuranceType;
}

const RadioSelect = ({
  title,
  label,
  labelPrivate,
  labelPublic,
  disableJourney,
  value,
  onChange,
  onButtonClick
}: RadioSelectProps): React.ReactElement => {
  const [disabled, setDisabled] = useState(!value);

  const onChangeSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedPrescription = (event.target as HTMLInputElement).value as InsuranceType;
    setDisabled(!selectedPrescription);
    onChange && onChange(selectedPrescription);
  };
  if (value !== undefined && disabled) {
    setDisabled(false);
  }

  const classes = useStyles();

  return (
    <>
      {title && (
        <Box pb={1}>
          <Typography className={classes.title} variant="h2">
            {title}
          </Typography>
        </Box>
      )}
      <Box pb={1}>
        <RadioGroup
          aria-label="prescriptionType"
          name="prescriptionType"
          value={value || ''}
          onChange={onChangeSelection}
        >
          <FormControlLabel
            data-qa-id={'private-radio-select'}
            value={InsuranceType.PRIVATE}
            control={<Radio />}
            disabled={disableJourney}
            label={labelPrivate}
          />
          {label && <Divider />}
          <FormControlLabel
            data-qa-id={'public-radio-select'}
            value={InsuranceType.PUBLIC}
            disabled={disableJourney}
            control={<Radio />}
            label={labelPublic}
          />
        </RadioGroup>
      </Box>
      {label && (
        <Button
          data-qa-id={'select-insurance-button'}
          color="primary"
          variant="contained"
          fullWidth
          disabled={disableJourney ? disableJourney : disabled}
          onClick={onButtonClick}
        >
          {label}
        </Button>
      )}
    </>
  );
};

export { RadioSelect };
